import type {Rental} from '@/types/Rental';

const pad = (value : number) : string => `${value}`.padStart(2, '0');

export const rentalReportType = (showCheckedOut : boolean) : string => {
    return showCheckedOut ? 'Items Currently Checked Out' : 'History';
};

export const rentalsForToggle = (rentals : Rental[], showCheckedOut : boolean) : Rental[] => {
    const status = showCheckedOut ? 'checked out' : 'returned';

    return rentals.filter(rental => rental.inOutStatus.toLowerCase().includes(status));
};

export const formatGeneratedDate = (date : Date) : string => {
    return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()}`;
};

export const rentalReportFileName = (
    personId : string,
    showCheckedOut : boolean,
    date : Date,
) : string => {
    const reportType = showCheckedOut ? 'CheckedOut' : 'History';
    const stamp = `${pad(date.getMonth() + 1)}${pad(date.getDate())}${date.getFullYear()}`;

    return `${personId}_${reportType}_${stamp}.pdf`;
};
